export default __webpack_public_path__ + "static/media/other_person.ea726681.jpg";